import { create } from "zustand";
import { persist } from "zustand/middleware";
import { cartService } from "../services";

export const useCartStore = create(
  persist(
    (set, get) => ({
      cartItems: [],
      totalItems: 0,
      loading: false,
      error: null,

      // Fetch cart from backend
      fetchCart: async () => {
        try {
          set({ loading: true });
          const response = await cartService.getCart();
          const items = response?.items || [];

          set({
            cartItems: items,
            totalItems: items.length,
            loading: false,
            error: null,
          });
        } catch (err) {
          console.error("Fetch cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      addToCart: async (assetId) => {
        try {
          set({ loading: true });

          const response = await cartService.addToCart(assetId);
          const items = response?.items || [];

          set({
            cartItems: items,
            totalItems: items.length, // ✅ update count immediately
            loading: false,
            error: null,
          });
        } catch (err) {
          console.error("Add to cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Remove item from backend cart
      removeFromCart: async (assetId) => {
        try {
          set({ loading: true });
          const response = await cartService.removeFromCart(assetId);
          set({
            cartItems: response?.items || [],
            loading: false,
            error: null,
          });
          get().fetchCartCount();
        } catch (err) {
          console.error("Remove from cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Clear backend cart
      clearCart: async () => {
        try {
          set({ loading: true });
          await cartService.clearCart();
          set({ cartItems: [], totalItems: 0, loading: false, error: null });
        } catch (err) {
          console.error("Clear cart error:", err);
          set({ loading: false, error: err.message });
        }
      },

      // Fetch total cart count
      fetchCartCount: () => {
        const items = get().cartItems || [];
        const count = Array.isArray(items) ? items.length : 0;
        set({ totalItems: count });
      },
    }),
    {
      partialize: (state) => ({
        cartItems: state.cartItems,
      }),
    },
  ),
);
